// removed by extract-text-webpack-plugin
module.exports = {"Book":"Book__Book__sDmom","Hours":"Book__Hours__1sp0w","social":"Book__social__1AHeD","socialicon":"Book__socialicon__ZyDcN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Book/Book.css
// module id = 59
// module chunks = 0